/**
 * Fragment de routes du paquet v4-p03-design (vague V4, règle R2 du découpage V4–V11 : un fragment par paquet).
 * Composants chargés à la demande (règle de chargement du registre), aucun code exécuté au chargement.
 * Routes du socle remplacées (`remplace: true`), d'après le `couvre: route:` des YAML d'écrans :
 *  - `/design/comparaisons/:id` → projet-design-comparaison-fiche ; `/design/tests-usage/:id` → projet-test-usage-fiche.
 *    Les écrans historiques `ComparaisonScreen` et `TestUsageScreen` ne sont plus servis ; leurs fichiers et App.tsx (gelé)
 *    restent inchangés.
 * Routes neuves (projet par `?projet=`, sinon le projet choisi dans la coquille) :
 *  - `/design/charte/preparer` → dialogue-preparer-charte ; `/design/chartes/:id` → projet-charte-fiche ;
 *  - `/design/parcours/:id` → projet-design-parcours-fiche.
 */
import { lazy, Suspense, type ComponentType, type JSX } from 'react'

import type { Session } from '../../auth/session'
import type { ContexteRoutes, FragmentRoutes } from './registre'

const DialoguePreparerCharte = lazy(() => import('../ecrans/v4/design/DialoguePreparerCharte'))
const FicheCharte = lazy(() => import('../ecrans/v4/design/FicheCharte'))
const FicheParcours = lazy(() => import('../ecrans/v4/design/FicheParcours'))
const FicheComparaison = lazy(() => import('../ecrans/v4/design/FicheComparaison'))
const FicheTestUsage = lazy(() => import('../ecrans/v4/design/FicheTestUsage'))

function ecran(Composant: ComponentType<{ session: Session }>) {
  return ({ session, t }: ContexteRoutes): JSX.Element => (
    <Suspense fallback={<p role="status">{t('v10.primitives.assemblage.chargement')}</p>}>
      <Composant session={session} />
    </Suspense>
  )
}

export const fragment: FragmentRoutes = {
  zone: 'v4-design',
  routes: [
    { chemin: '/design/charte/preparer', element: ecran(DialoguePreparerCharte) },
    { chemin: '/design/chartes/:id', element: ecran(FicheCharte) },
    { chemin: '/design/parcours/:id', element: ecran(FicheParcours) },
    { chemin: '/design/comparaisons/:id', element: ecran(FicheComparaison), remplace: true },
    { chemin: '/design/tests-usage/:id', element: ecran(FicheTestUsage), remplace: true },
  ],
}
